import Swal from "sweetalert2/dist/sweetalert2.js";

if (window.location.pathname.includes("placement/properties")) {
  let map, stepDisplay, autocomplete;

  let polyline;

  function load_directions(origin, destination) {
    let directionsDisplay = new google.maps.DirectionsRenderer();

    let directionsService = new google.maps.DirectionsService();

    directionsDisplay.set(map);

    let request = {
      origin: origin,
      destination: destination,
      travelMode: "DRIVING"
    };

    directionsService.route(request, function(response, status) {
      if (status == "OK") {
        if (typeof polyline !== "undefined") polyline.setMap(null);

        polyline = new google.maps.Polyline({
          path: [],
          strokeColor: "#FF0000",
          strokeWeight: 3
        });

        directionsDisplay.setDirections(response);

        var bounds = new google.maps.LatLngBounds();

        var legs = response.routes[0].legs;
        for (let i = 0; i < legs.length; i++) {
          var steps = legs[i].steps;
          for (let j = 0; j < steps.length; j++) {
            var nextSegment = steps[j].path;
            for (let k = 0; k < nextSegment.length; k++) {
              polyline.getPath().push(nextSegment[k]);
              bounds.extend(nextSegment[k]);
            }
          }
        }

        polyline.setMap(map);
        map.fitBounds(bounds);
      }
    });
  }

  function geocodeAddress(geocoder, resultsMap) {
    const address = document.getElementById("address-autocomplete").value;
    geocoder
      .geocode({ address: address })
      .then(({ results }) => {
        resultsMap.setCenter(results[0].geometry.location);
        new google.maps.Marker({
          map: resultsMap,
          position: results[0].geometry.location
        });
      })
      .catch(e => console.log("Geocode was not successful for the following reason:", e));
  }

  function load_map() {
    const geocoder = new google.maps.Geocoder();

    let loss_location = new google.maps.LatLng(app_data.placement.loss_address.address.latitude, app_data.placement.loss_address.address.longitude);

    map = new google.maps.Map(document.querySelector(".property-map"), {
      zoom: 3,
      center: loss_location
    });

    geocodeAddress(geocoder, map);
    map.setZoom(17);

    stepDisplay = new google.maps.InfoWindow();

    let loss_marker = new google.maps.Marker({
      position: loss_location,
      map: map
    });

    let location_marker;

    if (typeof app_data.property !== "undefined") {
      let location = new google.maps.LatLng(app_data.property.address.latitude, app_data.property.address.longitude);

      location_marker = new google.maps.Marker({
        position: location,
        map: map
      });

      load_directions(loss_location, location);
    }

    var input = document.getElementById("address-autocomplete");
    var options = {
      types: ["address"]
    };

    autocomplete = new google.maps.places.Autocomplete(input, options);

    autocomplete.setFields(["address_components", "geometry"]);

    var mutationObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === "autocomplete") {
          $("#address-autocomplete").attr("autocomplete", "new-password");
          mutationObserver.disconnect();
        }
      });
    });

    mutationObserver.observe(document.querySelector("#address-autocomplete"), {
      attributes: true
    });

    var componentForm = {
      subpremise: {
        name: "short_name",
        value: ""
      },
      street_number: {
        name: "short_name",
        value: ""
      },
      route: {
        name: "long_name",
        value: ""
      },
      locality: {
        name: "long_name",
        value: ""
      },
      administrative_area_level_1: {
        name: "long_name",
        value: ""
      },
      country: {
        name: "long_name",
        value: ""
      },
      postal_code: {
        name: "short_name",
        value: ""
      }
    };

    autocomplete.addListener("place_changed", function() {
      var place = autocomplete.getPlace();

      if (!place.geometry) {
        return;
      }

      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (componentForm[addressType]) {
          var val = place.address_components[i][componentForm[addressType]["name"]];
          componentForm[addressType]["value"] = val;
        }
      }

      let display = $("#address-autocomplete").closest("form");

      // var state = display.find("[name='address[state_id]'] option").filter(function(){return $(this).text()==componentForm['administrative_area_level_1']['value'];}).val();
      let state = app_options.states.find(function(option) {
        return option.text == componentForm["administrative_area_level_1"]["value"];
      });

      state = state && state.id;

      if (!state) {
        return Swal.fire({
          icon: "error",
          title: "Sorry",
          text: "Address not valid",
          heightAuto: false
        });
      }

      app.property.full_address = $(input).val();
      app.property.unit = componentForm["subpremise"]["value"];
      app.property.address.address = componentForm["street_number"]["value"] + " " + componentForm["route"]["value"];
      app.property.address.city = componentForm["locality"]["value"];
      app.property.address.state_id = state;
      app.property.address.state.name = componentForm["administrative_area_level_1"]["value"];
      app.property.address.zip = componentForm["postal_code"]["value"];

      var location = place.geometry.location;
      app.property.address.latitude = location.lat();
      app.property.address.longitude = location.lng();

      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
      } else {
        map.setCenter(location);
        map.setZoom(17);
      }
      if (typeof location_marker == "undefined") {
        location_marker = new google.maps.Marker({
          position: location,
          map: map
        });
      }
      location_marker.setPosition(location);

      var origin = new google.maps.LatLng(app.placement.loss_address.address.latitude, app.placement.loss_address.address.longitude);
      var destination = location;

      load_directions(origin, destination);

      var service = new google.maps.DistanceMatrixService();

      service.getDistanceMatrix(
        {
          origins: [origin],
          destinations: [destination],
          travelMode: "DRIVING",
          unitSystem: google.maps.UnitSystem.IMPERIAL
        },
        function(response, status) {
          if (status !== "OK") return;
          if (identify(response).rows[0].elements[0].distance(false) != false) {
            var distance = response["rows"][0]["elements"][0]["distance"];
            var value = distance.value * 0.000621371192;
            display.find("input[name='miles_from_loss']").val(parseFloat(value).toFixed(2));
          } else {
            var distance = parseFloat(getDistance(origin, destination));
            display.find("input[name='miles_from_loss']").val(distance.toFixed(2));
          }
        }
      );

      display.find("[name='address[address]']").trigger("update");
    });

    if (app.property && app.property.property_contacts) {
      app.property.property_contacts.forEach(c => contact_init(c));
    }
  }

  function contact_autocomplete(el, contactId) {
    const input = document.querySelector(el);
    const options = { types: ["address"] };
    const autocomplete = new google.maps.places.Autocomplete(input, options);
    autocomplete.setFields(["address_components", "geometry"]);

    const mutationObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === "autocomplete") {
          $(el).attr("autocomplete", "new-password");
          mutationObserver.disconnect();
        }
      });
    });

    if (!input) return;

    input.addEventListener("change", () => {
      const property_contact = app.property.property_contacts.find(c => c.id == contactId);
      setTimeout(() => (property_contact.contact.address.address = $(`.contact-${contactId} .contactOriginalAddress`).val()), 100);
    });

    mutationObserver.observe(input, { attributes: true });

    const componentForm = {
      street_number: { name: "short_name", value: "" },
      route: { name: "long_name", value: "" },
      locality: { name: "long_name", value: "" },
      administrative_area_level_1: { name: "long_name", value: "" },
      country: { name: "long_name", value: "" },
      postal_code: { name: "short_name", value: "" }
    };

    autocomplete.addListener("place_changed", function() {
      const place = autocomplete.getPlace();

      if (!place.geometry) {
        return;
      }

      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (componentForm[addressType]) {
          var val = place.address_components[i][componentForm[addressType]["name"]];
          componentForm[addressType]["value"] = val;
        }
      }

      let state = app_options.states.find(function(option) {
        return option.text == componentForm["administrative_area_level_1"]["value"];
      });

      state = state && state.id;

      const property_contact = app.property.property_contacts.find(c => c.id == contactId);
      const origValue = $(`.contact-${contactId} .contactOriginalAddress`);

      if (!state) {
        Swal.fire({
          icon: "error",
          title: "Sorry",
          text: "Address is not valid",
          heightAuto: false
        });
        property_contact.contact.address.address = origValue.val();
        return;
      }

      property_contact.contact.address.address = componentForm["street_number"]["value"] + " " + componentForm["route"]["value"];
      property_contact.contact.address.city = componentForm["locality"]["value"];
      property_contact.contact.address.state_id = state;
      property_contact.contact.address.state.name = componentForm["administrative_area_level_1"]["value"];
      property_contact.contact.address.zip = componentForm["postal_code"]["value"];

      origValue.val(property_contact.contact.address.address);
      const display = $(el).closest("form");
      display.find("[name='contact[address][address]']").trigger("update");
    });
  }

  window.contact_init = function(c) {
    const el = `.contact-${c.id} .contactAutocomplete`;
    $(`.contact-${c.id} .contactOriginalAddress`).val($(el).val());
    contact_autocomplete(el, c.id);
  };

  $(function() {
    if (typeof window.maps_loaded !== "undefined") {
      load_map();
    } else {
      window.initMap = load_map;
    }
  });

  $(window).on("property_rejected", function() {
    Swal.fire({
      type: "info",
      title: "Why reject property?",
      html: `<form id="property_reject" action="/api/property/update" method="POST">
        <div class="form-group">
          <div class="form-control-wrap">
            <textarea class="form-control" name="rejection_note"></textarea>
          </div>
        </div>
        <input type="hidden" name="id" v-model="id" />
        <button @click="click_it" class="btn btn-primary mt-2">Submit</button>
      </form>`,
      showConfirmButton: false,
      heightAuto: false,
      willOpen: () => {
        let click = false;
        $(window).on("/api/property/update.success", function(e, data) {
          if (!click) return;
          Swal.clickConfirm();
        });

        new Vue({
          el: "#property_reject",
          data: () => ({
            id: app.property.id
          }),
          mounted() {},
          methods: {
            click_it() {
              click = true;
            }
          }
        });
      }
    });
  });

  let firstPayment = $("[name=first_payment]").val() === "1";
  if (firstPayment) {
    $(".first-payable").show();
    $(".all-payable").hide();
  } else {
    $(".first-payable").hide();
    $(".all-payable").show();
  }

  $("[name=first_payment]")
    .on("change", function() {
      let val = $(this).val();
      if (val === "1") {
        $(".first-payable").show();
        $(".all-payable").hide();
      } else {
        $(".first-payable").hide();
        $(".all-payable").show();
      }
    })
    .trigger("change");

  $(document)
    .on("change", "select[name=payable_to_id]", function() {
      const val = $(this).val();
      const name = $(this)
        .parents(".payment-request")
        .find("[name=payable_to]");

      if (val == 1) {
        name.val(app_data.placement.policyholder.name);
      } else if (val == 3) {
        const agent = app.property.property_contacts.find(c => c.type === "Agent");
        if (agent) {
          name.val(agent.name);
        }
      }
    })
    .trigger("change");

  $("body").on("change", ".required_checkbox", function() {
    $(".swal2-deny").attr("disabled", !app.has_initial_payable);

    if (app.has_completed_initial_payment) {
      $(".swal2-deny").attr("disabled", true);
      $(".swal2-confirm").attr("disabled", true);
    } else {
      $(".swal2-confirm").attr("disabled", $(".required_checkbox:checked").length !== $(".required_checkbox").length);
    }
  });

  $("body").on("click", ".payable-action", function() {
    Swal.fire({
      title: "Initial Payables Request",
      html: `<div id="payableAction">
        <v-payable-request
          :placement="data.placement"
          :adjusters="data.adjusters"
          :property="data.property"
          :budget="data.budget"
          :has_completed_initial_payment="data.has_completed_initial_payment"
        ></v-payable-request>
      </div>`,
      icon: undefined,
      showCancelButton: true,
      confirmButtonColor: "#50C3CA",
      showDenyButton: true,
      denyButtonText: "Cancel Request",
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      cancelButtonText: "Close",
      reverseButtons: true,
      width: 1024,
      heightAuto: false,
      allowOutsideClick: () => !Swal.isLoading(),
      allowEscapeKey: () => !Swal.isLoading(),
      allowEnterKey: () => !Swal.isLoading(),
      preDeny: async () => {
        const data = { action: "cancel" };
        try {
          const result = await confirmUpdate(`/api/payable_action?property_id=${app.property.id}`, data);
          app.has_initial_payable = false;
          return result;
        } catch (e) {
          Swal.showValidationMessage(`There is something wrong!`);
          return false;
        }
      },
      preConfirm: async () => {
        const data = { action: "submit" };
        try {
          const result = await confirmUpdate(`/api/payable_action?property_id=${app.property.id}`, data);
          app.has_initial_payable = true;
          return result;
        } catch (e) {
          Swal.showValidationMessage(`There is something wrong!`);
          return false;
        }
      },
      onRender: () => {
        window.payableActionInstance = new Vue({
          el: `#payableAction`,
          data: {
            data: {
              placement: Object.assign({}, app.placement),
              adjusters: Object.assign({}, app.adjusters),
              property: Object.assign({}, app.property),
              budget: Object.assign({}, app.budget),
              has_completed_initial_payment: app.has_completed_initial_payment
            }
          }
        });

        $(".swal2-deny").attr("disabled", !app.has_initial_payable);

        if (app.has_completed_initial_payment) {
          $(".swal2-deny").attr("disabled", true);
          $(".swal2-confirm").attr("disabled", true);
          setTimeout(() => Swal.showValidationMessage(`Initial payment already completed.`), 0);
        } else {
          $(".swal2-confirm").attr("disabled", $(".required_checkbox:checked").length !== $(".required_checkbox").length);
        }
      }
    }).then(result => {
      app.budget = { ...window.payableActionInstance.data.budget };

      if (result.isConfirmed) {
        Swal.fire("Submitted", "Payable request is submitted.", "success");
      } else if (result.isDenied) {
        Swal.fire("Request Canceled", "Payable request is canceled.", "success");
      }
    });
  });

  $("body").on("click", ".invoice-action", function() {
    Swal.fire({
      title: "Initial Invoice Request",
      html: `<div id="invoiceAction">
        <v-invoice-request
          :placement="data.placement"
          :adjusters="data.adjusters"
          :property="data.property"
          :budget="data.budget"
          :temp="data.temp"
          :has_completed_initial_invoice="data.has_completed_initial_invoice"
        ></v-invoice-request>
      </div>`,
      icon: undefined,
      showCancelButton: true,
      cancelButtonText: "Close",
      confirmButtonColor: "#50C3CA",
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      width: 1024,
      heightAuto: false,
      allowOutsideClick: () => !Swal.isLoading(),
      allowEscapeKey: () => !Swal.isLoading(),
      allowEnterKey: () => !Swal.isLoading(),
      preConfirm: async () => {
        const data = { action: "submit" };
        try {
          const result = await confirmUpdate(`/api/invoice_action?property_id=${app.property.id}`, data);
          return result;
        } catch (e) {
          Swal.showValidationMessage(`There is something wrong!`);
          return false;
        }
      },
      onRender: () => {
        window.invoiceActionInstance = new Vue({
          el: `#invoiceAction`,
          data: {
            data: {
              placement: Object.assign({}, app.placement),
              adjusters: Object.assign({}, app.adjusters),
              property: Object.assign({}, app.property),
              budget: Object.assign({}, app.budget),
              temp: { management_fees: [], rents: [] },
              has_completed_initial_invoice: app.has_completed_initial_invoice
            }
          }
        });

        if (app.has_completed_initial_invoice) {
          $(".swal2-confirm").attr("disabled", true);
          setTimeout(() => Swal.showValidationMessage(`Initial invoice already completed.`), 0);
        }
      }
    }).then(result => {
      app.budget = { ...window.invoiceActionInstance.data.budget };
      app.budget.line_items = [
        ...Array.from(window.invoiceActionInstance.data.temp.rents),
        ...Array.from(window.invoiceActionInstance.data.temp.management_fees)
      ].map(item => ({ ...item, amount: window.realFloat(item.amount) }));

      if (result.isConfirmed) {
        Swal.fire("Submitted", "Invoice request is submitted.", "success");
      } else if (result.isDenied) {
        Swal.fire("Request Canceled", "Invoice request is canceled.", "success");
      }
    });
  });

  function confirmUpdate(url, data) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url,
        method: "POST",
        data,
        dataType: "json",
        success: response => resolve(response),
        error: response => reject(response)
      });
    });
  }

  $(window).on("/api/checklist/update.success", function(e, data) {
    const checklist = data.checklist;
    if (!checklist) return;

    app_data.budget.initial_payment_checklist[checklist.payable_key] = checklist.checked;
  });

  $(window).on(`/api/payable_action?property_id=${app_data.property_id}.success`, function(e, data) {
    const checklist = data.checklist;
    if (!checklist) return;

    checklist.forEach(item => {
      const move_in_key = 2;
      const checklist_item = app_data.checklists.move_in.items[move_in_key].find(i => i.id === item.checklist_id);

      if (!checklist_item) return;

      checklist_item.checked = item.checked;
    });
  });

  if ($(".table-property-options").length) {
    const options = {
      columnDefs: [
        {
          render: function(data, type, row) {
            return `<div class="d-flex justify-content-center">
                <button class="btn btn-secondary mx-2 btn-view-qualifying-action" data-id="${row.id}">View</button>
                <button class="btn btn-secondary mx-2 btn-move-qualifying-action" data-id="${row.id}">Action</button>
            </div>`;
          },
          targets: "col-action"
        }
      ]
    };

    const propertyTypes = {
      single: "Single Family Home",
      townhouse: "Townhouse",
      apartment: "Apartment",
      condo: "Condo"
    };

    const amenitiesLabels = {
      appliances: {
        aircon: "A/C",
        dishwasher: "Dishwasher",
        microwave: "Microwave",
        refrigerator: "Refrigerator",
        stove: "Stove"
      },
      amenities: {
        fenced_yard: "Fenced Yard",
        ranch_style: "Ranch Style",
        handicap_accessible: "Handicap Accessible",
        walk_in_shower: "Walk-in Shower",
        balcony: "Balcony / Deck",
        finished_basement: "Finished Basement",
        lawn_care: "Lawn Care",
        snow_removal: "Snow Removal",
        swimming_pool: "Swimming Pool",
        utilities: "Utilities Included"
      },
      laundry: {
        none: "None",
        in_unit: "In unit",
        shared: "Shared / In-building"
      },
      flooring: {
        carpet: "Carpet",
        hardwood: "Hardwood",
        other: "Other"
      },
      windows: {
        blinds: "Blinds",
        drapes: "Drapes",
        shades: "Shades",
        none: "None"
      }
    };

    $(".table-property-options").data("options", options);

    $(".data-table").on("click", ".btn-view-qualifying-action", function(e) {
      const table = $(this).closest(".data-table");
      const tr = $(this)
        .closest("tr")
        .get(0);
      const data = table
        .DataTable()
        .row(tr)
        .data();

      Swal.fire({
        title: "Property Details",
        html: getPropertyDetails(data),
        icon: undefined,
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Delete",
        confirmButtonColor: "#28a745",
        confirmButtonText: "Move to Possible Properties",
        showLoaderOnConfirm: true,
        reverseButtons: true,
        heightAuto: false,
        width: 1024,
        preDeny: async () => await updateProperty(data, "delete"),
        preConfirm: async () => await updateProperty(data, "move"),
        didOpen: () => addDismissButton(data)
      }).then(result => {
        if (result.isDismissed) {
          return;
        } else if (result.value) {
          Swal.fire("Completed", result.value.message, "success");

          if (result.value.property) app.properties.possible.push(result.value.property);
        }

        updateTable($(".data-table.table-property-options"), options, app.property_option_table_keys);
      });
    });

    $(".data-table").on("click", ".btn-move-qualifying-action", function() {
      const table = $(this).closest(".data-table");
      const tr = $(this)
        .closest("tr")
        .get(0);
      const data = table
        .DataTable()
        .row(tr)
        .data();

      Swal.fire({
        title: "Move Property",
        icon: "info",
        showDenyButton: true,
        denyButtonText: "Delete",
        confirmButtonColor: "#28a745",
        showCancelButton: true,
        confirmButtonText: "Move to Possible Properties",
        reverseButtons: true,
        preDeny: async () => await updateProperty(data, "delete"),
        preConfirm: async () => await updateProperty(data, "move"),
        didOpen: () => addDismissButton(data)
      }).then(result => {
        if (result.isDismissed) {
          return;
        } else if (result.value) {
          Swal.fire("Completed", result.value.message, "success");

          if (result.value.property) app.properties.possible.push(result.value.property);
        }

        updateTable($(".data-table.table-property-options"), options, app.property_option_table_keys);
      });
    });

    function addDismissButton(data) {
      const pendingButton = document.createElement("button");
      pendingButton.textContent = "Dismiss";
      pendingButton.classList.add("swal2-deny", "swal2-submit", "swal2-styled");
      pendingButton.style.backgroundColor = "#c7a723";
      pendingButton.type = "button";
      pendingButton.addEventListener("click", () => dismissPropertyModal(data));

      const denyButton = document.querySelector(".swal2-deny");
      denyButton.parentNode.insertBefore(pendingButton, denyButton.nextSibling);
    }

    function dismissPropertyModal(data) {
      Swal.fire({
        input: "textarea",
        inputLabel: "Why dismissing?",
        inputPlaceholder: "Type your reason here...",
        inputAttributes: {
          "aria-label": "Type your reason here"
        },
        showCancelButton: true,
        confirmButtonText: "Dismiss",
        showLoaderOnConfirm: true,
        reverseButtons: true,
        heightAuto: false,
        preConfirm: async note => await updateProperty(data, "dismiss", { note })
      }).then(result => {
        if (result.isDismissed) {
          return;
        }

        Swal.fire("Dismissed", "Property is dismissed.", "success");

        updateTable($(".data-table.table-property-options"), options, app.property_option_table_keys);
      });
    }

    async function updateProperty(data, action, additional_data = {}) {
      try {
        const btn = document.querySelector(".swal2-submit") || {};
        btn.disabled = true;
        const payload = {
          placement_id: app.placement.id,
          qualifying_property_id: data.id,
          action,
          ...additional_data
        };
        const response = await confirmUpdate(`/api/qualifying_property/update`, payload);

        btn.disabled = false;
        return response;
      } catch (e) {
        btn.disabled = false;
        Swal.showValidationMessage(`There is something wrong!`);
        return false;
      }
    }

    function updateTable(table, options, columns) {
      if (!$.fn.dataTable.isDataTable(table)) {
        console.error("Incorrect datatable component!");
        return;
      }

      table.DataTable().destroy();
      table.empty();
      let html = "<thead><tr>";
      let header = columns;
      for (let i in header) {
        html += `<td data-column="${i}" class="col-${i}">${header[i]}</td>`;
      }
      html += "</tr></thead>";
      table.html(html);
      table.data("options", options);
      window.dataTableInstance(table);
      $("[name='invoice_search']").trigger("keyup");
    }

    function getPropertyValue(data, propertyPath) {
      const pathParts = propertyPath.split(".");

      let result = data;
      for (let part of pathParts) {
        if (result && result[part] !== undefined) {
          result = result[part];
        } else {
          return [];
        }
      }

      return result || [];
    }

    function getPropertyDetails(data) {
      const landlord = data.landlord ? JSON.parse(data.landlord) : {};
      const details = data.details ? JSON.parse(data.details) : {};
      const amenities = data.amenities ? JSON.parse(data.amenities) : {};

      return `<div class="row text-left">
        <div class="col col-md-6 mb-4">
            <h3>Landlord Information</h3>
            <p class="mb-0"><strong>First Name:</strong> ${landlord.first_name || "-"}</p>
            <p class="mb-0"><strong>Last Name:</strong> ${landlord.last_name || "-"}</p>
            <p class="mb-0"><strong>Management Company:</strong> ${landlord.company || "-"}</p>
            <p class="mb-0"><strong>Phone:</strong> ${landlord.phone || "-"}</p>
            <p class="mb-0"><strong>Cell Phone:</strong> ${landlord.cellphone || "-"}</p>
            <p class="mb-0"><strong>Email:</strong> ${landlord.email || "-"}</p>
            <p class="mb-0"><strong>Billing Address:</strong> ${landlord.address || "-"}</p>
        </div>
        <div class="col col-md-6 mb-4">
            <h3>Property Information</h3>
            <p class="mb-0"><strong>Property Type:</strong> ${propertyTypes[data.type] || "-"}</p>
            <p class="mb-0"><strong>Property Address:</strong> ${data.address || "-"}</p>
            <p class="mb-0"><strong>Property City:</strong> ${data.city || "-"}</p>
            <p class="mb-0"><strong>Property State:</strong> ${data.state || "-"}</p>
            <p class="mb-0"><strong>Property Zip:</strong> ${data.zip || "-"}</p>
            <p class="mb-0"><strong>Unit Number:</strong> ${data.unit_number || "-"}</p>
            <p class="mb-0"><strong>Complex:</strong> ${data.complex || "-"}</p>
        </div>

        <div class="col col-md-6 mb-4">
            <h3>Details and Description</h3>
            <p class="mb-0"><strong>Monthly Rent Price:</strong> $${window.formatMoney(details.monthly_rent) || "0.00"}</p>
            <p class="mb-0"><strong>Minimum Lease Duration:</strong> ${details.lease_duration || "-"}</p>
            <p class="mb-0"><strong>Refundable Security Deposit Amount:</strong> $${window.formatMoney(details.security_deposit) || "0.00"}</p>
            <p class="mb-0"><strong>Date Available:</strong> ${details.date_available ? moment(details.date_available).format("MM/DD/YYYY") : "-"}</p>
            <p class="mb-0"><strong>Bedrooms:</strong> ${details.bedrooms || "0"}</p>
            <p class="mb-0"><strong>Bathrooms:</strong> ${details.baths || "0"}</p>
            <p class="mb-0"><strong>Square Footage:</strong> ${details.sqft || "0"}</p>
            <p class="mb-0"><strong>Parking:</strong> ${details.parking || "0"}</p>
            <p class="mb-0"><strong>Property Website:</strong> <a href="${details.website}" target="_blank">${details.website || ""}</a></p>
            <p class="mb-0"><strong>School District:</strong> ${details.school_district || "-"}</p>
        </div>
        <div class="col col-md-6 mb-4">
            <h3>Amenities and Specifications</h3>
            <p class="mb-0"><strong>Pets Allowed:</strong> ${amenities.pets}</p>
            <p class="mb-0"><strong>Furnished:</strong> ${amenities.furnished}</p>
            <p class="mb-0"><strong>Appliances:</strong></p>
            <ul class="mb-0">
                ${getPropertyValue(amenities, "appliances")
                  .map(amenity => `<li>${amenitiesLabels.appliances[amenity] || "-"}</li>`)
                  .join("")}
            </ul>
            <p class="mb-0"><strong>Amenities:</strong></p>
            <ul class="mb-0">
                ${getPropertyValue(amenities, "amenities")
                  .map(amenity => `<li>${amenitiesLabels.amenities[amenity] || "-"}</li>`)
                  .join("")}
            </ul>
            <p class="mb-0"><strong>Flooring:</strong> ${(amenities && amenitiesLabels.laundry[amenities.laundry]) || "-"}</p>
            <p class="mb-0"><strong>Flooring:</strong></p>
            <ul class="mb-0">
                ${getPropertyValue(amenities, "flooring")
                  .map(amenity => `<li>${amenitiesLabels.flooring[amenity] || "-"}</li>`)
                  .join("")}
            </ul>
            <p class="mb-0"><strong>Windows:</strong></p>
            <ul class="mb-0">
                ${getPropertyValue(amenities, "windows")
                  .map(amenity => `<li>${amenitiesLabels.windows[amenity] || "-"}</li>`)
                  .join("")}
            </ul>
        </div>
    </div>`;
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/properties.js